<script setup>
  import {
    onMounted,
    ref
  } from 'vue'

  import { useI18n } from '@shared/i18n.js'

  const { vt } = useI18n('properties.index.js')

  const selected = ref(window.app.page.search_key.features || [])

  const FEATURES = [
    'furnished',
    'no_key_money',
    'no_deposit',
    'no_agency_fee',
    'no_guarantor',
    'luxury',
  ]

  onMounted(() => {
    $(".sort_item_features select").on('sumo:closed', () => {
      if (JSON.stringify(window.app.page.search_key.features || []) === JSON.stringify(selected.value)) {
        return
      }
      const url = new URL(window.location.href)
      url.searchParams.delete('features[]')
      selected.value.forEach((value) => url.searchParams.append('features[]', value))
      window.location.href = url.toString()
    })
  })
</script>

<template>
  <div class="sort_item sort_item_features">
    <label class="select_type_a">
      <select v-model="selected" class="search-property-type-detail select_pc" multiple="multiple" :placeholder="vt('features')" tabindex="-1">
        <option v-for="feature in FEATURES" :key="`feature-#{feature}`" :value="feature">{{ vt(feature) }}</option>
      </select>
    </label>
  </div>
</template>
